import React from 'react'
import { Dealer } from 'types/Dealer'

type Props = {
  dealer: Pick<Dealer, 'id' | 'name' | 'companyBrand' | 'distributor' | 'address' | 'city' | 'state' | 'zip' | 'phoneNumber' | 'lastLoggedInUser' > | null
}

const DealerInfo = ({ dealer }: Props) => {
  return (
    <>
      {dealer &&
        <>
          <div>{dealer.name}</div>
          <div>{dealer.companyBrand + ' - ' + dealer.distributor}</div>
          <div>{dealer.name + ' - ' + dealer.id}</div>
          <div>{dealer.address}</div>
          <div>{[dealer.city, dealer.state, dealer.zip].join(', ')}</div>
          <div>{dealer.phoneNumber}</div>
          <div>{dealer.lastLoggedInUser}</div>
        </>
      }
    </>
  )
}

export default DealerInfo
